// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notFoundImageContainer {
  height: 87vh;
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column !important;
}
.notFoundImage {
  width: 70%;
  height: auto;
}
.notFoundLink {
  text-decoration: none;
}
.notFoundBtn {
  background-color: #4f46e5;
  border: none;
  outline: none;
  border-radius: 20px;
  color: #fff;
  display: flex;
  font-size: 1rem;
  padding: 10px 20px !important;
  text-align: center;
  box-shadow: 0 0 40px 40px #4f46e5 inset, 0 0 0 0 #4f46e5;
  margin: 30px 0 10px 0;
  text-decoration: none;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  font-weight: bold;
}

.notFoundBtn:hover {
  text-decoration: none;
  color: #4f46e5;
  background-color: transparent;
  box-shadow: 0 0 10px 0 #4f46e5 inset, 0 0 10px 4px #4f46e5;
}
.aaa {
  padding: 10px;
  width: 70%;
  height: 150px;
  /* font-family: Inter !important; */
  font-family: Estedad !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/NotFound/NotFound.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,wDAAwD;EACxD,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,mCAAmC;EACnC,+BAA+B;AACjC","sourcesContent":[".notFoundImageContainer {\r\n  height: 87vh;\r\n  display: flex !important;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column !important;\r\n}\r\n.notFoundImage {\r\n  width: 70%;\r\n  height: auto;\r\n}\r\n.notFoundLink {\r\n  text-decoration: none;\r\n}\r\n.notFoundBtn {\r\n  background-color: #4f46e5;\r\n  border: none;\r\n  outline: none;\r\n  border-radius: 20px;\r\n  color: #fff;\r\n  display: flex;\r\n  font-size: 1rem;\r\n  padding: 10px 20px !important;\r\n  text-align: center;\r\n  box-shadow: 0 0 40px 40px #4f46e5 inset, 0 0 0 0 #4f46e5;\r\n  margin: 30px 0 10px 0;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: all 150ms ease-in-out;\r\n  font-weight: bold;\r\n}\r\n\r\n.notFoundBtn:hover {\r\n  text-decoration: none;\r\n  color: #4f46e5;\r\n  background-color: transparent;\r\n  box-shadow: 0 0 10px 0 #4f46e5 inset, 0 0 10px 4px #4f46e5;\r\n}\r\n.aaa {\r\n  padding: 10px;\r\n  width: 70%;\r\n  height: 150px;\r\n  /* font-family: Inter !important; */\r\n  font-family: Estedad !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
